/**
 * Search history for AI Prescription — in-memory only (no PHI in sessionStorage).
 */

import { SearchSession } from "./types";

const EXPIRY_TIME = 60 * 60 * 1000; // 1 hour
let inMemoryHistory: SearchSession[] = [];

/**
 * Validates and filters expired search history items (memory only).
 */
export const validateSearchHistory = (): SearchSession[] => {
  const currentTime = new Date().getTime();
  inMemoryHistory = inMemoryHistory.filter(
    (item) => currentTime < item.expiryDate
  );
  return [...inMemoryHistory];
};

/**
 * Sets a new search session in history (not persisted to browser storage).
 */
export const setSessionForSearch = (query: string): SearchSession[] => {
  if (!query.trim()) {
    return validateSearchHistory();
  }
  const newSearchItem: SearchSession = {
    question: query,
    expiryDate: new Date().getTime() + EXPIRY_TIME,
  };
  const validSearchHistory = validateSearchHistory();
  inMemoryHistory = [newSearchItem, ...validSearchHistory];
  return [...inMemoryHistory];
};

/** Clear AI search history (e.g. on logout). */
export function clearSearchHistory(): void {
  inMemoryHistory = [];
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem("aiPrescriptionSearchHistory");
  }
}
